import { Row, Col } from "antd";

import Text from "./Text";

const DetailLabel = ({ label, value }) => (
  <Row>
    <Col span={4}>
      <Text>{label}</Text>
    </Col>
    <Col span={20}>
      <Text fontSize={14} fontWeight={600}>
        {value}
      </Text>
    </Col>
  </Row>
);

export default DetailLabel;
